'use strict';

var repeat = require('repeat-string');

module.exports = footnoteDefinition;

function footnoteDefinition(node) {
  var id = node.identifier.toLowerCase();
  var content = this.all(node).join('\n\n' + repeat(' ', 4));

  return '[^' + id + ']: ' + content;
}



//////////////////
// WEBPACK FOOTER
// ./~/remark/~/remark-stringify/lib/visitors/footnote-definition.js
// module id = 289
// module chunks = 147254134005266 182246549230831 215303740077764